import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  snapDefaultDebug,
  unSnapDefaultDebug,
} from "store/bailiff/(default)/debug/default_debug.action";
//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    dispatch(snapDefaultDebug());
    return () => dispatch(unSnapDefaultDebug());
  }, [dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
